import { useRef } from "react";
import { Tooltip } from "src/components/Tooltip/Tooltip";
import { Flex, Icon, Color } from "src/elements";
import { useHoverClickable } from "src/utils/hoverClickable";
import { styled } from "styled-components";

const SidepanelToggleElement = styled(Flex)`
  width: 100%;
  justify-content: center;
  align-items: center;
  aspect-ratio: 1;
`;

interface Props {
  isLocked: boolean;
  setIsLocked: (isLocked: boolean) => void;
}

export const SidepanelLockButton = ({ isLocked, setIsLocked }: Props) => {
  const refButton = useRef(null);
  const { isHovered, isActive } = useHoverClickable(refButton);

  return (
    <SidepanelToggleElement
      ref={refButton}
      background={
        (isActive && Color.greenSmokeActive) ||
        (isHovered && Color.greenSmokeHover) ||
        Color.greenSmokeDisabled
      }
      onClick={() => setIsLocked(!isLocked)}
    >
      <Icon
        name={isLocked ? "locked" : "unlocked"}
        color={((isHovered || isActive) && Color.primaryActive) || Color.primary}
      />

      <Tooltip position="left">{isLocked ? "Unlock Tabs" : "Lock Tabs"}</Tooltip>
    </SidepanelToggleElement>
  );
};
